import {defineStore} from "pinia";

export const useSidebarStore = defineStore("sidebar", {
  state: () => ({
    open: false,
  }),
  getters: {
    isOpen: (state) => state.open
  },
  actions: {
    switchState() {
      this.open = !this.open;
    },
    openSidebar() {
      this.open = true;
    },
  }
})